export default "__VITE_ASSET__30fe0ad9__"